import { render, staticRenderFns } from "./table.admin.vue?vue&type=template&id=3213902a&"
import script from "./table.admin.vue?vue&type=script&lang=ts&"
export * from "./table.admin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports